// extracted by mini-css-extract-plugin
export default {"container":"O+url","descriptionTitle":"NcWNe","description":"ygwdQ","organizationNumber":"ntd4q","startEditButtonContainer":"Gv9qd","editor":"Fp7uJ","editButtons":"+OdON"};